"use client";

import {
  fetchCommerceProduct,
  PRO_SUBSCRIPTION_SLUG,
} from "@/lib/api/commerce";

// Shared entry points for the two `ssr: false` modal chunks.
//
// AppShell declares them via `next/dynamic`, which only starts the download
// when the modal is first rendered — i.e. on click. Importing through the same
// specifier here resolves to the same chunk, so warming it in advance means
// the click has nothing left to fetch.

export const importProModal = () => import("@/components/layout/ProModal");
export const importAuthModal = () => import("@/components/layout/AuthModal");

/** Locales whose Pro price has already been requested this session. */
const warmedPriceLocales = new Set<string>();

/**
 * Warm everything the Pro modal needs before it is opened: its JS chunk and
 * the price it would otherwise only start fetching on mount.
 *
 * Safe to call repeatedly — the dynamic import is memoized by the bundler and
 * the price request is both de-duplicated and cached. Pass `locale` only once
 * it is hydrated, so the prefetch uses the same key the modal will read.
 */
export function preloadProModal(locale?: string): void {
  void importProModal();

  if (locale === undefined || warmedPriceLocales.has(locale)) return;
  warmedPriceLocales.add(locale);
  void fetchCommerceProduct(PRO_SUBSCRIPTION_SLUG, locale).catch(() => {
    // Let a real open retry and surface the error in the modal.
    warmedPriceLocales.delete(locale);
  });
}
